<script setup>
import { nextTick, reactive, ref } from "vue";
import { queryCustomFormTable } from "@/api/customForm";

const emits = defineEmits(["formSelected"]);

const visible = ref(false);

// 遮罩
const loading = ref(true);

// 选中数组
const ids = ref([]);

// 总条数
const total = ref(0);

// 预览弹窗
const previewForm = ref(false);

// 表单列表
const formList = ref([]);

// 预览组件ref
const previewRef = ref(null);

const formJson = ref({});

// 分页数据
const pages = reactive({
  page: 1,
  limit: 10,
  total: 10,
});

/** 查询自定义表单列表 */
const getList = () => {
  loading.value = true;

  queryCustomFormTable({
    page: pages.page,
    limit: pages.limit,
    state: "1",
  })
    .then((res) => {
      formList.value = res.data.records;
      pages.total = res.data.total;
    })
    .finally(() => {
      loading.value = false;
    });
};

// 多选框选中数据
const handleSelectionChange = (selection) => {
  ids.value = selection.map((item) => item.formKey);
};

// 弹窗打开
const handleDialogOpen = () => {
  visible.value = true;
  getList();
};

// 点击预览
const handlePreviewForm = (row) => {
  formJson.value = JSON.parse(row.content);
  nextTick(() => {
    previewRef.value?.setFormJson(JSON.parse(row.content));
  });

  previewForm.value = true;
};

// 表单选择结束回调
const submitForm = () => {
  visible.value = false;
  emits("formSelected", ids.value);
};

// 暴露函数
defineExpose({
  handleDialogOpen,
});
</script>

<template>
  <el-dialog title="表单选择" v-model="visible" width="70%" append-to-body>
    <el-table
      v-loading="loading"
      :data="formList"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column
        label="id"
        align="center"
        prop="id"
        show-overflow-tooltip
      />
      <el-table-column label="表单key" align="center" prop="formKey" />
      <el-table-column label="表单名" align="center" prop="formName" />
      <el-table-column label="表单类型" align="center" prop="formType.desc" />
      <el-table-column label="备注" align="center" prop="remark" />
      <el-table-column label="状态" align="center" prop="state.desc" />
      <el-table-column
        label="表单地址"
        align="center"
        prop="formUrl"
        show-overflow-tooltip
      />
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template #default="{ row }">
          <el-button
            size="small"
            type="primary"
            link
            icon="el-icon-view"
            @click="handlePreviewForm(row)"
            >预览</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-show="total > 0"
      :total="total"
      :current-page="pages.page"
      @update:current-page="getList"
    />

    <template #footer>
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </template>
  </el-dialog>

  <el-dialog
    title="表单预览"
    v-model="previewForm"
    width="800px"
    append-to-body
  >
    <v-form-render
      ref="previewRef"
      :form-json="formJson"
      :form-data="{}"
    ></v-form-render>
  </el-dialog>
</template>

<style scoped></style>
